export function queryError(payload) {
  return new Error(payload.data?.text || payload.data?.message || 'AI request failed.');
}

export function queryResult(payload, previous) {
  return {
    ...previous,
    text: payload.data?.text ?? '',
    queryId: payload.metadata?.query_id ?? previous?.queryId,
    ready: payload.done,
  };
}

export function askQuery(ai, id, params, context) {
  return new Promise((resolve, reject) => {
    ai.queryAsk(id, params, context, {
      onPayload: (payload) => {
        if (payload.status === 'error') {
          reject(queryError(payload));
        } else if (payload.type === 'message' && payload.done) {
          resolve(payload.data?.text ?? '');
        }
      },
    }).catch(reject);
  });
}
